/* @flow */
export const RESET_PASSWORD_TOKEN_COOKIE = 'resetPasswordToken';

// exported so it can be used client-side in src/routes.js and server-side in lib/server.common.js
export const RESET_PASSWORD_PATH = '/reset_password';



// WEBPACK FOOTER //
// ./src/constants/AuthConstants.js